// @ is an alias to /src

export default {
  name: 'Navbar',
  components: {

  }
}